<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="height:100%;" v-loading="loading" :element-loading-text="loadingText">
    <el-tabs class="zj-plan-resource-sett no-active-bar" height="100%" v-model="activeName">
      <el-tab-pane
        :key="item.name"
        v-for="(item) in EmergencyTaskSubType"
        :label="item.Description"
        :name="item.ItemKey"
      >
        <ComponentRescueteamsDetail
          v-if="item.ItemKey=='EmergencyTaskType.Resource.Rescue'"
          :ref="item.ItemKey"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.ItemKey"
          @loading="showLoading"
          @loadingFinish="hideLoading"
        />
        <ComponentsupplieDetail
          v-if="item.ItemKey=='EmergencyTaskType.Resource.Meterial'"
          :ref="item.ItemKey"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.ItemKey"
          @loading="showLoading"
          @loadingFinish="hideLoading"
        />
        <ComponentshelterDetail
          v-if="item.ItemKey=='EmergencyTaskType.Resource.Shelter'"
          :ref="item.ItemKey"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.ItemKey"
          @loading="showLoading"
          @loadingFinish="hideLoading"
        />
        <ComponentCommunicationDetail
          v-if="item.ItemKey=='EmergencyTaskType.Resource.Communication'"
          :ref="item.ItemKey"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.ItemKey"
          @loading="showLoading"
          @loadingFinish="hideLoading"
        />
        <ComponentMedicalDetail
          v-if="item.ItemKey=='EmergencyTaskType.Resource.Medical'"
          :ref="item.ItemKey"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.ItemKey"
          @loading="showLoading"
          @loadingFinish="hideLoading"
        />
        <ComponentTransportDetail
          v-if="item.ItemKey=='EmergencyTaskType.Resource.Transport'"
          :ref="item.ItemKey"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.ItemKey"
          @loading="showLoading"
          @loadingFinish="hideLoading"
        />
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>
<script>
import ComponentRescueteamsDetail from "./ComponentRescueteamsDetail";
import ComponentsupplieDetail from "./ComponentsupplieDetail";
import ComponentshelterDetail from "./ComponentshelterDetail";
import ComponentCommunicationDetail from "./ComponentCommunicationDetail";
import ComponentMedicalDetail from "./ComponentMedicalDetail";
import ComponentTransportDetail from "./ComponentTransportDetail";
import MyApis from "../../../apis";

export default {
  name: "ZjResourcesSettingInfo",
  controller: "UI",
  action: "ResourcesSettingInfo",
  components: {
    ComponentRescueteamsDetail,
    ComponentsupplieDetail,
    ComponentshelterDetail,
    ComponentCommunicationDetail,
    ComponentMedicalDetail,
    ComponentTransportDetail
  },
  props: {
    PlanTaskId: { type: String }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      activeName: "",
      EmergencyTaskSubType: [],
      ruleForm: {
        PlanTaskId: this.$props.PlanTaskId
      }
    };
  },
  created: function() {
    this.loadingRef = 0;
    this.showLoading('加载中...');
    this.config
      .getUValue("EmergencyService:EmergencyTaskType-Resource", "")
      .then(d => {
        var data = d.JValue;
        if (data) {
          this.activeName = data[0].ItemKey;
          this.EmergencyTaskSubType = data;
          this.hideLoading();
          this.search();
        }
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.hideLoading();
      });
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    showLoading(text) {
      this.loadingRef++;
      this.loading = true;
      this.loadingText = typeof(text) !== 'undefined' && text !== null ? text : '加载中...'
    },
    hideLoading() {
      this.loadingRef--;
      if (this.loadingRef == 0) {
        this.loading = false;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    search() {
      let PlanTaskId = this.PlanTaskId;
      if (PlanTaskId != null && PlanTaskId != "") {
        let searchInfo = {
          PlanTaskId: PlanTaskId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.showLoading('加载中...');
        new MyApis.PlantasksettingApi()
          .FindByConditions(searchInfo)
          .then(r => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.ruleForm = data[0];
              this.setActiveName(this.ruleForm.TaskSubTypeId);
            }
            this.hideLoading();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    setActiveName(taskSubTypeId) {
      if (this.EmergencyTaskSubType && this.EmergencyTaskSubType.length > 0) {
        var item = this.EmergencyTaskSubType.find(a => {
          return a.ItemKey == taskSubTypeId;
        });

        if (item) {
          this.activeName = item.ItemKey;
        }
      }
    }
  }
};
</script>
<style>
.zj-plan-resource-sett .el-tabs__header {
  border: none;
}
.zj-plan-resource-sett .is-active {
  background: url(/img/tabselected.png) no-repeat !important;
  background-size: 100% 100% !important;
  background-position: center !important;
}
.zj-plan-resource-sett .el-tabs__active-bar {
  display: none;
}
.zj-plan-resource-sett .el-tabs__item {
  width: 16rem;
  text-align: -webkit-center;
}
.zj-plan-resource-sett .el-tabs__item {
  background: url(/img/tab.png) no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
</style>